import { FormSchema } from './form-schema';
import { sanitizeFormKey } from '@utils/form-keys';
import { validRslDimensionSlug } from '../../constants/dimensions';
import { RslReport } from '@features/campaigns/subdomains/rsl';

export const buildDefaultValues = (
  campaignName: string,
  report?: RslReport
): FormSchema => ({
  campaignName,
  salesObjectives: [
    {
      value:
        'Drive incremental sales and traffic through a multi-channel media approach.',
    },
    {
      value:
        'Identify best media audiences to reach our ideal customer target.',
    },
  ],
  footTrafficObjectives: [
    {
      value:
        'Drive incremental sales and traffic through a multi-channel media approach.',
    },
    {
      value:
        'Identify best media audiences to reach our ideal customer target.',
    },
  ],
  subdimensionImagesByNameAndValue: report
    ? report.dimensions.reduce(
        (acc, dimension) => {
          const dimName = dimension.dimensionName;
          if (!validRslDimensionSlug(dimName)) return acc;
          if (typeof acc[dimName] !== 'object') {
            acc[dimName] = {};
          }
          (acc[dimName] as Record<string, unknown>)[
            sanitizeFormKey(dimension.dimensionValue)
          ] = null;
          return acc;
        },
        {} as FormSchema['subdimensionImagesByNameAndValue']
      )
    : {},
  includedSlides: {
    intro: {
      title: true,
      agenda: true,
      howWeDoIt: true,
    },
    salesLift: {
      cover: true,
      campaignOverview: true,
      campaignOverview2: true,
      who: true,
      what: true,
      where: true,
      optimizationSummary: true,
    },
    visitLift: {
      cover: true,
      overview: true,
      who: true,
      what: true,
      where: true,
    },
    campaignInsights: {
      cover: true,
      audienceProfile: true,
      demographicProfile: true,
      topLocations: true,
      moreStats: true,
      visitorProfile: true,
    },
  },
});
